import type { State } from '../../types';
import type { PartnerViewModel } from '@trinnvis/dabih-api-client';
import { _sortByName } from '../utilities/_sortByName';
import { toList } from '../toList';

export function partnersDeleted(state: State): PartnerViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.partnersById)
    .filter(function (e) {
      return e.deleted;
    })
    .sort(_sortByName);
}
